module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"updateBtn":"更新肿瘤细胞分类"},"en":{"updateBtn":"Update Tumor Cell Classifying"}}')
  delete Component.options._Ctor
}
